import { render, staticRenderFns } from "./otherAuth.vue?vue&type=template&id=8d63e3a8&scoped=true"
import script from "./otherAuth.vue?vue&type=script&lang=js"
export * from "./otherAuth.vue?vue&type=script&lang=js"
import style0 from "./otherAuth.vue?vue&type=style&index=0&id=8d63e3a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d63e3a8",
  null
  
)

export default component.exports